import { Badge, Button, ButtonGroup, Grid } from '@material-ui/core';
import { css } from 'aphrodite';
import { FC } from 'react';
import {
  BallastHeightLevel,
  BallastHeightLevelType,
  ElastometerTagsConfig,
} from '../../../../interfaces/tenstilTest';
import { colors } from '../../../../styles/colors';
import { useCurrentLanguage } from '../../../../translations/languageSelector';
import { styles } from './TensilTests.styles';

export type StateProps = {
  elastometer: BallastHeightLevel;
};

type TensileTestDirectionLevelsProps = StateProps;

export const TensileTestElastometerRow: FC<TensileTestDirectionLevelsProps> = ({
  elastometer,
}) => {
  const activeLang = useCurrentLanguage();

  const isPull = elastometer?.type !== BallastHeightLevelType.PUSH;

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      style={{ position: 'relative', paddingBottom: 5 }}
    >
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: 1,
          backgroundColor: colors.grey,
        }}
      />
      <Grid item>
        <ButtonGroup>
          <Button
            variant="outlined"
            size="small"
            disabled
            style={{ height: 30 }}
            className={css(isPull ? styles.activeButton : styles.button)}
          >
            {activeLang.treeDetailPage.tensilTest.pull}
          </Button>
          <Button
            variant="outlined"
            size="small"
            disabled
            style={{ height: 30 }}
            className={css(!isPull ? styles.activeButton : styles.button)}
          >
            {activeLang.treeDetailPage.tensilTest.push}
          </Button>
        </ButtonGroup>
      </Grid>
      <Grid item style={{ height: 30, zIndex: 1 }}>
        <Grid container alignItems="center" style={{ gap: 15 }}>
          <input
            value={`${elastometer.height?.toString() ?? ''} cm`}
            className={css(styles.input)}
            disabled
            readOnly
          />
          <Badge
            style={{ backgroundColor: elastometer?.color ?? 'white' }}
            className={css(styles.elastometer)}
          >
            {ElastometerTagsConfig[elastometer?.name].name}
          </Badge>
        </Grid>
      </Grid>
    </Grid>
  );
};
